import type { ReactNode } from 'react';
import type { CaseChecklistPayload } from './checklist/caseChecklist';

export type VcaCheckStepConfig =
    | { readonly kind: 'caseChecklist' }
    | { readonly kind: 'clinicMessages'; readonly warning: ReactNode };

export type VcaCheckStepKind = VcaCheckStepConfig['kind'];

const BLOCKING_HINT: Record<VcaCheckStepKind, string> = {
    caseChecklist: 'Sign off the checks',
    clinicMessages: 'Confirm the clinic messages check'
};

export function checkStepHint(kind: VcaCheckStepKind, confirmed: boolean): string | null {
    return confirmed ? null : BLOCKING_HINT[kind];
}

// Only the case checklist is recorded on the trigger; the clinic messages tick is a local gate.
export function recordsCaseChecklist(kind: VcaCheckStepKind): boolean {
    return kind === 'caseChecklist';
}

export function toChecklistPayload(
    kind: VcaCheckStepKind,
    confirmed: boolean
): CaseChecklistPayload | undefined {
    return recordsCaseChecklist(kind) && confirmed ? { confirmed: true } : undefined;
}
